import { Services } from "../components/ServiceInterface";
import { build_url } from "./Api";
import { fetchJson, RequestInitGet } from "./request";

class GlobalService {
    async services(): Promise<Services> {
        return (await fetchJson(build_url("services"), RequestInitGet))
    }
}

export default GlobalService;
